module.exports = {"password":"Password","Period":"Period","Employee_ID":"Employee ID","Employee_Name":"Employee Name","Statement_Date":"Statement Date"}


//////////////////
// WEBPACK FOOTER
// ./i18n/locales/en.json
// module id = 1108
// module chunks = 249